/* CP V2.8: one client-side eligibility function, matched by cp-purchase-state.liquid.
   Shopify remains authoritative at cart/checkout. No inventory or price overrides. */
(function (w) {
  'use strict';
  function state(variant, options) {
    options = options || {};
    if (!variant || !variant.id) return 'unavailable';
    var amount = options.amount == null ? Number(variant.price) : Number(options.amount);
    if (options.priceOnRequest || !Number.isFinite(amount) || amount <= 0) return 'no-price';
    if (!variant.available) return 'out-of-stock';
    var quantity = Number(options.quantity == null ? (variant.quantityMin || 1) : options.quantity);
    if (!Number.isSafeInteger(quantity) || quantity < 1) return 'invalid-quantity';
    var min = Number(variant.quantityMin || 1), step = Number(variant.quantityIncrement || 1);
    if (quantity < min || (quantity - min) % step !== 0 || (variant.quantityMax != null && quantity > Number(variant.quantityMax))) return 'invalid-quantity';
    if (options.equipment && variant.inventoryManaged && Number(variant.inventoryQuantity) < quantity) return 'out-of-stock';
    if (options.mode === 'quote') return 'quote-only';
    if (variant.requiresSellingPlan && !options.plan) return 'plan-required';
    return 'ready';
  }
  var messages = {
    'no-price': 'Price on request. Enquire for the correct configuration and a quotation.',
    'out-of-stock': 'Not enough stock for this quantity online. Enquire for availability and a quotation.',
    'quote-only': 'Please enquire for a quotation before ordering.',
    'plan-required': 'A valid purchase plan is required for this option.',
    'unavailable': 'Choose a valid product option.',
    'invalid-quantity': 'Choose a whole-number quantity within this option’s order limits.',
    'ready': 'Ready to order. Check the selected option and quantity before adding to your basket.'
  };
  w.CPPurchaseState = { evaluate: state, message: function (s) { return messages[s] || messages.unavailable; } };
})(window);
